import {
  OmniReport_Create,
  OmniReport_Read,
  OmniReport_Update,
  OmniReportContentType,
  ReportCategory_Read,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class OmniReport {
  public static parse(proto: OmniReport_Read): OmniReport {
    return new OmniReport(
      proto.id,
      proto.name,
      proto.content_id,
      proto.content_type,
      proto.system,
      proto.report_category ? ReportCategory.parse(proto.report_category) : null,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public static deparse(omniReport: OmniReport): OmniReport_Create {
    return {
      name: omniReport.name,
      content_id: omniReport.contentId,
      content_type: omniReport.contentType,
      system: omniReport.system,
      report_category_id: omniReport.reportCategory?.id ?? '',
    };
  }

  public static deparseUpdate(omniReport: OmniReport): OmniReport_Update {
    return {
      name: omniReport.name,
      content_id: omniReport.contentId,
      report_category_id: omniReport.reportCategory?.id ?? '',
    };
  }

  public get name() {
    return this._name;
  }
  public get id() {
    return this._id;
  }
  public get contentId() {
    return this._contentId;
  }
  public get contentType() {
    return this._content_type;
  }
  public get isApp() {
    return this._content_type === OmniReportContentType.APP;
  }
  public get isBuilder() {
    return this._content_type === OmniReportContentType.BUILDER;
  }
  public get system() {
    return this._system;
  }
  public get reportCategory() {
    return this._reportCategory;
  }
  public get discardedAt() {
    return this._discarded_at;
  }

  constructor(
    private _id: string,
    private _name: string,
    private _contentId: string,
    private _content_type: OmniReportContentType,
    private _system: boolean,
    private _reportCategory: ReportCategory | null,
    private _discarded_at: Dayjs | null = null,
  ) {}
}

export class ReportCategory {
  public static parse(proto: ReportCategory_Read): ReportCategory {
    return new ReportCategory(
      proto.id,
      proto.name,
      proto.system,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public get name() {
    return this._name;
  }
  public get id() {
    return this._id;
  }
  public get system() {
    return this._system;
  }
  public get discardedAt() {
    return this._discarded_at;
  }

  constructor(
    private _id: string,
    private _name: string,
    private _system: boolean,
    private _discarded_at: Dayjs | null = null,
  ) {}
}
